import { useState } from "react";
import { useAuthContext } from "../hooks/useAuthContext";
import { usePostsContext } from "../hooks/usePostsContext";
import { useQuery } from "@apollo/client";
import { GET_POSTS } from "../queries/postQueries";
import { MdOutlineSaveAlt } from "react-icons/md";
import Spinner from "./Spinner";

export default function SavePostButton({ postId }) {
  const { authUser, refetchUserProfile } = useAuthContext()
  const { savePost } = usePostsContext()

  const { data: savedData, loading: savedLoading, error: savedError, refetch } = useQuery(GET_POSTS, {
    variables: { id: authUser.id, feedType: 'saved' },
  })

  const [isLoading, setIsLoading] = useState(false)

  if (savedLoading) return <Spinner />
  if (savedError) return <p>Error loading saved posts data: {savedError.message}</p>

  const savedPosts = savedData.posts

  const onClickSavePost = async () => {
    setIsLoading(true)
    
    await savePost({ variables: { userId: authUser.id, postId } })
    await refetchUserProfile(authUser.id)
    await refetch()

    setIsLoading(false)
  }

  const isThisPostSaved = savedPosts.some((save) => {
    return save.id === postId
  })

  return (
    <button
      type='button'
      className='btn btn-sm border-0'
      onClick={onClickSavePost}
    >
      {/*isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>*/}
      {/*!isLoading && */isThisPostSaved && <MdOutlineSaveAlt style={{ color: '#9c27b0' }} className="rfs-1" />}
      {/*!isLoading && */!isThisPostSaved && <MdOutlineSaveAlt className="rfs-1" />} 
    </button>
  )
}